

































import {Component, Vue, Watch} from "vue-property-decorator";
import KawaiiButton from "@/components/infrastructures/atoms/KawaiiButton.vue";
import httpResource from "@/components/infrastructures/functions/http/httpResource";
import KawaiiDialog from "@/components/infrastructures/atoms/KawaiiDialog.vue";

@Component({
  components: {KawaiiDialog, KawaiiButton}
})
export default class DMVDeleteTab extends Vue {
  name = "DMVDeleteTab";

  headers = [
    // {text: "ID", value: "id"},
    {text: "ファイル名", value: "fileName"},
    {text: "コース", value: "course"},
    {text: "表情種別", value: "cluster"},
    {text: "LINK", value: "path"}
  ];

  selected: {}[] = [];
  vibrationList: {}[] = [];

  diabledDelete = true;

  // dialog
  dialog = false;
  dialogMessage = "";

  mounted() {
    this.fetchDMVList();
  }

  fetchDMVList() {
    httpResource.get("/upload/aiesthe-dmv-list")
        .then((response: any) => {
          this.vibrationList = response.data;
        });
  }

  deleteAction() {
    if (this.diabledDelete) {
      return;
    }

    const selected = this.selected[0] as any;

    httpResource.post(`/upload/delete-aiesthe-dmv?id=${selected.id}`)
        .then((response: any) => {
          this.dialogMessage = "削除に成功しました。";
          this.fetchDMVList();
        })
        .catch((error: any) => {
          // console.log(error)
          this.dialogMessage = "削除に失敗しました。";
        })
        .finally(() => {
          this.dialog = true;
        });
  }

  @Watch("selected")
  watchDiabledDelete() {
    this.diabledDelete = this.selected.length === 0;
  }
}
